import React, { useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  DialogActions,
  FormControl,
  InputAdornment,
  DialogContent,
  DialogTitle,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/VisibilityOutlined";
import VisibilityOff from "@material-ui/icons/VisibilityOffOutlined";
import { useStyles } from "../style";
import { groupAdminUserValidation, orgAdminUserValidation } from "./validation";
// import { useValidation } from "../../../../components/validation";
import SelectComponent from "../../../../components/select";
import Calendar from "../../../../components/calendar";
import { GroupSelection } from "../../../../components/group-select";
import useForm from "../../../../hooks/useForm";
import moment from "moment";

const initialValues = {
  firstName: "",
  lastName: "",
  username: "",
  password: "",
  gender: "Male",
  dob: moment().format("YYYY-MM-DD"),
  groupIds: [],
};

function AddUser(props) {
  const classes = useStyles();
  const { openAddUser, closeHandler, addHandler, loader, isGroupAdminMode } = props;
  const { values, errors, handleChange, handleFormSubmit } = useForm(
    initialValues,
    isGroupAdminMode ? groupAdminUserValidation : orgAdminUserValidation,
    addHandler
  );
  // console.log(values, "values");
  // console.log(errors, "errors");
  // const { validation, validate, autoValidate, isValid } = useValidation(isGroupAdminMode ? groupAdminUserValidation : orgAdminUserValidation);
  // const [user, setUser] = useState({
  //   firstName: "",
  //   lastName: "",
  //   username: "",
  //   password: "",
  //   gender: "",
  //   dob: null,
  //   groupIds: [],
  // });
  const [showPassword, setShowPassword] = useState(false);

  // function handleAdd() {
  //   autoValidate(true);
  //   if (isValid) {
  //     addHandler(user);
  //   }
  // }

  // function handleInputChange(field, value) {
  //   debugger;
  //   setUser({ ...user, [field]: value });
  //   validate(validation[field], value);
  // }

  // function handleDobChange(field, value) {
  //   setUser({ ...user, [field]: value });
  //   validate(validation[field], value.format("YYYY-MM-DD"));
  // }

  return (
    <div className={classes.root}>
      {loader && (
        <Grid container className={classes.loader} justify="center" alignItems="center" alignContent="center">
          <CircularProgress />
        </Grid>
      )}
      <Dialog open={openAddUser} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth classes={classes.dialog}>
        <DialogTitle id="form-dialog-title" className={classes.dialogHeader}>
          Add User
        </DialogTitle>
        <DialogContent className={classes.paddingSpacer}>
          <FormControl fullWidth>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  autoFocus
                  id="firstname"
                  label="First name"
                  variant="outlined"
                  inputProps={{ maxLength: "100" }}
                  type="text"
                  fullWidth
                  size="small"
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  // onBlur={(e) => validate(validation["firstName"], e.target.value)}
                  onChange={(e) => handleChange("firstName", e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="lastname"
                  label="Last name"
                  variant="outlined"
                  inputProps={{ maxLength: "100" }}
                  type="text"
                  size="small"
                  fullWidth
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                  // onBlur={(e) => validate(validation["lastName"], e.target.value)}
                  onChange={(e) => handleChange("lastName", e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <Calendar
                  label="DOB"
                  name="dob"
                  position="right"
                  fullWidth
                  value={values?.dob}
                  error={!!errors.dob}
                  helperText={errors.dob}
                  otherProps={{ maxDate: new Date() }}
                  onChange={(date) => {
                    handleChange("dob", date.format("YYYY-MM-DD"));
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectComponent
                  value={values?.gender}
                  label="Gender"
                  options={[
                    {
                      id: "Male",
                      name: "Male",
                    },
                    {
                      id: "Female",
                      name: "Female",
                    },
                    {
                      id: "Others",
                      name: "Others",
                    },
                  ]}
                  error={!!errors?.gender}
                  helperText={errors?.gender}
                  onChange={(e) => handleChange("gender", e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Email"
                  variant="outlined"
                  type="text"
                  size="small"
                  // InputProps={{
                  //   endAdornment: (
                  //     <InputAdornment position="end">
                  //       {currentUser.domainname ? `@${currentUser.domainname}` : ""}
                  //     </InputAdornment>
                  //   ),
                  // }}
                  inputProps={{
                    maxLength: "50",
                  }}
                  fullWidth
                  error={!!errors.username}
                  helperText={errors.username}
                  // onBlur={(e) => validate(validation["username"], e.target.value)}
                  onChange={(e) => handleChange("username", e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="password"
                  label="Password"
                  variant="outlined"
                  size="small"
                  fullWidth
                  className={classes.miniFieldGridBottom}
                  type={showPassword ? "text" : "password"}
                  autoComplete="new-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)}>{showPassword ? <Visibility /> : <VisibilityOff />}</IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.password}
                  helperText={errors.password}
                  // onBlur={(e) => validate(validation["password"], e.target.value)}
                  onChange={(e) => handleChange("password", e.target.value)}
                />
              </Grid>
              {isGroupAdminMode ? null : (
                <Grid item xs={12}>
                  <GroupSelection service={props?.service} name={"groupIds"} error={errors?.groupIds} handleChange={handleChange} />
                </Grid>
              )}
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions className={classes.dialogAction}>
          <Button onClick={handleFormSubmit} variant="contained" color="primary">
            Add
          </Button>
          <Button onClick={() => closeHandler(false)} variant="contained" className={classes.actionButton}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddUser;
